import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, List, ListItem, ListItemText,
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import useStyles from './styles';

export default function ResultsSection({ necessaryProductsQuantity }) {
  const [headerDisplay, setHeaderDisplay] = useState('none');
  const [pdfDisplay, setPdfDisplay] = useState('none');
  const [csvDisplay, setCsvDisplay] = useState('none');
  const classes = useStyles();

  useEffect(() => {
    if (necessaryProductsQuantity.items) {
      setHeaderDisplay('block');
    }

    if (necessaryProductsQuantity.summaryUrlPDF) {
      setPdfDisplay('block');
    }

    if (necessaryProductsQuantity.summaryUrlCSV) {
      setCsvDisplay('block');
    }
  }, [necessaryProductsQuantity]);

  return (
    <>
      <Box className={classes.resultsContainer}>
        <Box
          className={classes.resultsHeader}
          style={{ display: headerDisplay }}
        >
          Quantity Results
        </Box>
        <Box className={classes.resultsSection}>
          <List>
            {necessaryProductsQuantity.items?.map((item) => (
              <ListItem
                className={classes.listItem}
                key={item['@id']}
              >
                <ListItemText
                  className={classes.listItemText}
                  primary={item.description}
                  secondary={item.itemQuantity}
                />
              </ListItem>
            ))}
          </List>
        </Box>
        <Box className={classes.buttonContainer}>
          <Box
            className={classes.summaryUrl}
            style={{ display: pdfDisplay }}
          >
            <a
              className={classes.urlText}
              href={necessaryProductsQuantity.summaryUrlPDF}
              target="_blank"
              rel="noreferrer"
            >
              Download PDF
              <GetAppIcon className={classes.downloadIcon} />
            </a>
          </Box>
          <Box
            className={classes.summaryUrl}
            style={{ display: csvDisplay }}
          >
            <a
              className={classes.urlText}
              href={necessaryProductsQuantity.summaryUrlCSV}
            >
              Download CSV
              <GetAppIcon className={classes.downloadIcon} />
            </a>
          </Box>
        </Box>
      </Box>
    </>
  );
}

ResultsSection.propTypes = {
  necessaryProductsQuantity: PropTypes.objectOf(PropTypes.any).isRequired,
};
